module.exports = new __parcel__URL__("silver1.51ca2532.png").toString();